import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabComponent } from '@syncfusion/ej2-angular-navigations';
import { AuthenService } from '../../services/authen.service';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Query, DataManager, ODataV4Adaptor, Predicate  } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { MyDataAdaptor } from '../../helpers/grid.adaptor';
import * as AppConst from '../../data/test.data';
import { ReportParaFilter } from '../../models/report/report-para-filter.model';
import { CustListString } from '../../models/report/cust-list-string.model';
import { DatePipe } from '@angular/common';
import { MultiSelectCust } from '../../models/report/multi-select-cust.model';
import { GridComponent, ToolbarItems, ExcelExportProperties  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { debug } from 'util';
import { DropDownList } from "../../models/dropdownlist.model";
import { saveAs as importedSaveAs } from "file-saver";
import { ChangeEventArgs, SelectEventArgs } from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: '',
    templateUrl: './report.document.html'
})
export class ReportDocumentComponent implements OnInit {

    public userLogin: string = '';
    public lstPrnStr: string = '';
    public lstCustStr: string = '';
    public show: boolean = false;

    //statusReport: Array<any> = ['All','Open', 'Waiting for principal approve', 'Principal approved', 'Waiting tender result', 'Win', 'Lost', 'Cancel'];
    //Area: Array<any> = ['All','HCM', 'HN', 'SOU', 'NOR', 'MEK', 'CEN'];
    //Detail: Array<any> = ['All', 'Tender', 'Renewal', 'Tender supplement', 'Price Application', 'Apply tender result', 'Direct purchase tender'];
    statusReport: Array<any> = [];
    Area: Array<any> = [];
    Detail: Array<any> = [];
    dateFormat = "dd/MM/yyyy";
    public dateValueFrom: Date = new Date();
    public dateValueTo: Date = new Date();
    public statusReportSelected: string = '';
    public areaSelected: string = '';
    public detailSelected: string = '';
    public empListPRN: Array<any> = [];
    public empListCust: Array<any> = [];
    public strFromYear: string = '';
    public strToYear: string = '';
    public strFromMonth: string = '';
    public strToMonth: string = '';
    public dataPRN: Array<any> = [];
    public principalDDL: Array<any> = [];

    reportParaFilter = new ReportParaFilter();
    public placeholder: string = 'Select Principal';
    public placeholderCust: string = 'Select Customer';
    public dataReport: DataManager;
    public toolbarOptions: ToolbarItems[];
    @ViewChild('grid') public grid: GridComponent;

    public pageSettings: PageSettingsModel;

    //// maps the appropriate column to fields property
    public fields: Object = { text: 'label', value: 'value' };
    public sorting: string = 'Ascending';
    public custMTS: Array<MultiSelectCust> = [];

    // multi select cust name - area
    public data: DataManager;
    public custMTS2: Array<CustListString> = [];
    public text: string = "Select Customer";
    public box: string = 'box'; 
    public fields2: Object = { text: 'CustomerName', value: 'CustomerCode' };
    public query: Query;
    public empListCust2: Array<any> = [];
    //public query: Query = new Query().from('VS_CustomerFilter').select(['CustomerCode', 'CustomerName','CustAddr3']);

    //Autocomplete Cust
    public dataAutocomplete: DataManager;
    public textAutocomplete: string = "Find a customer";
    public textCustSelected: string = "";
    public textCustSelectedTemp: string = "";


    constructor(private http: HttpService, private helper: HelperService, private datePipe: DatePipe, private auth: AuthenService) {
        this.getCustMTS();
        //this.pageSettings = { pageSize: 50 };
    }

    ngOnInit(): void  {
        //this.getAllPrn();
        //this.toolbarOptions = ['ExcelExport'];
    }

    //toolbarClick(args: ClickEventArgs): void {
    //    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
    //        const excelExportProperties: ExcelExportProperties = {
    //            fileName: 'Summary Procurement by customers.xlsx'
    //        };
    //        this.grid.excelExport(excelExportProperties);
    //    }
    //}

    //getAllPrn() {
    //    debugger
    //    this.http.get('api/PrincipalUser/GetAllPRN', res => {
    //        this.dataPRN = res;
    //    }, null);
    //}

    //getPrnByUser() {
    //    debugger
    //    if (this.auth.isZPV) {
    //        this.principalCode = 'All';
    //        this.userLogin = this.auth.LoginUser;
    //        this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
    //            this.dataPRN = res;
    //        }, null);
    //    }
    //    else {
    //        this.userLogin = this.auth.LoginUser;
    //        this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
    //            this.dataPRN = res;
    //        }, null);
    //    }
    //}

    //getPrincipalDDL() {
    //    debugger
    //    this.http.get('api/PrincipalUser/GetAllPrincipalDDL', res => {
    //        this.principalDDL = res;
    //        var allOption = new DropDownList();
    //        allOption.label = "All";
    //        allOption.value = 0;
    //        this.principalDDL.push(allOption);
    //    }, null);

    //    this.dataPRN = this.principalDDL.map(t => t.label);
    //}

    getCustMTS(){
        //this.http.get('api/Report/GetCustomer', res => {
        //    this.data = res;
        //}, null);
        debugger
        if (this.auth.isZPV) {
            this.userLogin = this.auth.LoginUser;
            this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
                this.dataPRN = res;
                this.dataPRN.push('All');
            }, null);
        }
        else {
            this.userLogin = this.auth.LoginUser;
            this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
                this.dataPRN = res;
            }, null);
        }
        this.dataPRN.sort();

        this.http.get('api/Report/GetCustomerCodeAndName', res => {
            this.dataAutocomplete = res;
            //if (this.auth.isZPV) {
            //    this.userLogin = this.auth.LoginUser;
            //    this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
            //        this.dataPRN = res;
            //        this.dataPRN.push('All');
            //    }, null);
            //    this.dataPRN.push('All');
            //}
            //else {
            //    this.userLogin = this.auth.LoginUser;
            //    this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
            //        this.dataPRN = res;
            //    }, null);
            //}
        }, null);

        this.http.get('api/Report/GetVS_Area/', res => {
            this.Area = res;
        }, null);

        this.http.get('api/Report/Get_VS_TenderStatus/', res => {
            this.statusReport = res;
        }, null);

        this.http.get('api/Report/Get_VS_TenderDetail/', res => {
            this.Detail = res;
        }, null);
    }

    //autocomplete
    //public onFilteringAutocomplete(e) {
    //    e.preventDefaultAction = true;
    //    var predicate = new Predicate('CustomerName', 'contains', e.text);
    //    predicate = predicate.or('CustAddr3', 'contains', e.text);
    //    var query = new Query();
    //    //frame the query based on search string with filter type.
    //    query = (e.text != "") ? query.where(predicate) : query;
    //    //pass the filter data source, filter query to updateData method.
    //    e.updateData(this.dataAutocomplete, query);
    //}

    //onFilteringCust(event) {
    //    this.empListCust.push(event.value);
    //}

    //onFilteringCust2(event) {
    //    this.empListCust2.push(event.value);
    //}

    onFiltering(event) {
        this.empListPRN.push(event.value);
    }

    changeStatusReport(ev) {
        this.statusReportSelected = ev.value;
    }
    changeAreaReport(ev) {
        this.areaSelected = ev.value;
    }

    changeDetialReport(ev) {
        this.detailSelected = ev.value;
    }

    convertDateToString() {
        if (!this.statusReportSelected || 0 === this.statusReportSelected.length) {
            this.statusReportSelected = 'All';
        }

        if (!this.areaSelected || 0 === this.areaSelected.length) {
            this.areaSelected = 'All';
        }

        if (!this.detailSelected || 0 === this.detailSelected.length) {
            this.detailSelected = 'All';
        }

        if (!this.empListPRN || 0 === this.empListPRN.length) {
            //this.lstPrnStr = 'All';
            //this.lstPrnStr = String(this.dataPRN[0]);
            if (this.auth.isZPV) {
                this.lstPrnStr = 'All';
            }
            else {
                this.lstPrnStr = String(this.dataPRN[0]);
            }
        }
        else {
            this.lstPrnStr = this.empListPRN.join(";");
        }

        //if (!this.empListCust2) {
        //    this.lstCustStr = 'All';
        //}
        //else {
        //    this.empListCust = this.empListCust2.map(t => t.CustomerCode);
        //    this.lstCustStr = this.empListCust.join(";");
        //}

          
        if (!this.textCustSelected || 0 === this.textCustSelected.length) {
            this.textCustSelected = "All";
            this.textCustSelectedTemp = this.textCustSelected;
        }
        else if (this.textCustSelected.includes(" = ")) {
            this.textCustSelected = this.textCustSelected.split(" = ")[2];
            this.textCustSelectedTemp = this.textCustSelected;
        }

        let fromDate = this.datePipe.transform(this.dateValueFrom, 'yyyyMMdd');
        let toDate = this.datePipe.transform(this.dateValueTo, 'yyyyMMdd');
        this.strFromYear = fromDate.substring(0, 4);
        this.strToYear = toDate.substring(0, 4);
        this.strFromMonth = fromDate.substring(4, 6);
        this.strToMonth = toDate.substring(4, 6);

        this.reportParaFilter.FromMonth = this.strFromMonth;
        this.reportParaFilter.FromYear = this.strFromYear;
        this.reportParaFilter.ToMonth = this.strToMonth;
        this.reportParaFilter.ToYear = this.strToYear;
        this.reportParaFilter.Status = this.statusReportSelected;
        this.reportParaFilter.Area = this.areaSelected;
        this.reportParaFilter.Detail = this.detailSelected;
        this.reportParaFilter.Principal = this.lstPrnStr;
        this.reportParaFilter.CustCode = this.textCustSelected;

    }
    onExportClick() {
        debugger
        var element = <HTMLInputElement>document.getElementById("btnExcel");
        element.disabled = true;

        this.convertDateToString();
        //this.dataReport = new DataManager({url: `${this.http.baseUrl}api/Report/GetPage?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&ToMonth=${this.reportParaFilter.ToMonth}&ToYear=${this.reportParaFilter.ToYear}&Status=${this.reportParaFilter.Status}&Area=${this.reportParaFilter.Area}&Detail=${this.reportParaFilter.Detail}&Principal=${this.reportParaFilter.Principal}&CustCode=${this.reportParaFilter.CustCode}`, adaptor: new MyDataAdaptor(this.helper), crossDomain: true });

        this.show = true;
        this.http.download(`api/Report/ExportVS_ReportByDocument?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&ToMonth=${this.reportParaFilter.ToMonth}&ToYear=${this.reportParaFilter.ToYear}&Status=${this.reportParaFilter.Status}&Area=${this.reportParaFilter.Area}&Detail=${this.reportParaFilter.Detail}&Principal=${this.reportParaFilter.Principal}&CustCode=${this.reportParaFilter.CustCode}&fromDate=${this.datePipe.transform(this.dateValueFrom, 'yyyy-MM-dd')}&toDate=${this.datePipe.transform(this.dateValueTo, 'yyyy-MM-dd')}`, res => {
            importedSaveAs(res, "Monitor Tender Document Preparation Time.xlsx");
            this.show = false;
            element.disabled = false;
        });
        
    }

    //onActionFailure(e: Error): void {
    //    this.helper.alert(e.message);
    //}

    onChangedCustomer(e) {
        if (e.item) {
            this.textCustSelected = e.itemData;
        } else {
            this.textCustSelected = "";
        };

    }

}
